export enum Page {
  LogIn = 'LogIn',
  ForgotPassword = 'ForgotPassword',
  ForgotUsername = 'ForgotUsername',
  LoginInterceptors = 'LoginInterceptors'
}
